import { render, staticRenderFns } from "./MemberRegistForm.vue?vue&type=template&id=52798adb&scoped=true&"
import script from "./MemberRegistForm.vue?vue&type=script&lang=js&"
export * from "./MemberRegistForm.vue?vue&type=script&lang=js&"
import style0 from "./MemberRegistForm.vue?vue&type=style&index=0&id=52798adb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52798adb",
  null
  
)

export default component.exports